import React from 'react';
import moment from 'moment';
import { Tag } from 'antd';
import HighlightComponent from 'components/HighlightComponent';
import { DATE_FORMAT, STATUS } from 'constants/app-constants';
import GRNUpdateFunctional from './components/grn-update-functional';
import './invoice-validation.scss';

const GRNUpdate = () => {
	return <GRNUpdateFunctional />;
};

export const column = [
	{
		title: 'LR #',
		dataIndex: 'lrNumber',
		align: 'left',
		fixed: 'left',
		width: 100,
		sorter: (a, b) => a?.lrNumber - b?.lrNumber,
	},
	{
		title: 'Inbound No',
		dataIndex: 'loadId',
		align: 'left',
		fixed: 'left',
		width: 100,
		sorter: (a, b) => a?.loadId?.loadNumber - b?.loadId?.loadNumber,
		render: (value) => (
			<HighlightComponent
				highlightClassName="highlightClass"
				autoEscape={true}
				textToHighlight={value?.loadNumber?.toString() || ''}
			/>
		),
	},
	{
		title: 'GRN #',
		dataIndex: 'grnNumber',
		align: 'left',
		fixed: 'left',
		width: 100,
		sorter: (a, b) => a?.grnNumber - b?.grnNumber,
	},
	{
		title: 'GRN Date',
		dataIndex: 'grnDate',
		align: 'left',
		width: 150,
		sorter: (a, b) => new Date(a.grnDate) - new Date(b.grnDate),
		render: (value) => <span>{value ? moment(value).format(DATE_FORMAT.DD_MM_YYYY) : '-'}</span>,
	},
	{
		title: 'Inbound Date',
		dataIndex: 'loadId',
		align: 'left',
		width: 150,
		sorter: (a, b) => new Date(a.loadId?.loadInDate) - new Date(b.loadId?.loadInDate),
		render: (value) => <span>{moment(value?.loadInDate).format(DATE_FORMAT.DD_MM_YYYY)}</span>,
	},
	{
		title: 'Vehicle No',
		dataIndex: 'loadId',
		sorter: (a, b) => a?.loadId?.vehicleId?.regNumber - b?.loadId?.vehicleId?.regNumber,
		key: 'loadId',
		width: 150,
		render: (value) => (
			<HighlightComponent
				highlightClassName="highlightClass"
				autoEscape={true}
				textToHighlight={value?.vehicleId?.regNumber || ''}
			/>
		),
	},
	{
		title: 'Vendor Name',
		dataIndex: 'vendorId',
		key: 'vendorId',
		sorter: (a, b) => a?.vendorId?.vendorName?.localeCompare(b?.vendorId?.vendorName),
		width: 150,
		render: (value) => <span>{value?.vendorName}</span>,
	},
	{
		title: 'Part No',
		dataIndex: 'partNumberId',
		key: 'partNumberId',
		sorter: (a, b) => a?.partNumberId?.partNumber?.localeCompare(b?.partNumberId?.partNumber),
		width: 100,
		render: (value) => <span>{value?.partNumber}</span>,
	},
	{
		title: 'Sap No',
		dataIndex: 'partNumberId',
		key: 'partNumberId',
		width: 100,
		render: (value) => <span>{value?.sapNumber}</span>,
	},
	{
		title: 'Invoice No',
		dataIndex: 'invoiceNumber',
		width: 100,
		sorter: (a, b) => a?.invoiceNumber - b?.invoiceNumber,
		key: 'invoiceNumber',
		render: (value, row) => (
			<>
				{row?.status === 'InStock' ? (
					value
				) : (
					<div
						style={{
							cursor: 'pointer',
							color: '#1b59a8',
							textDecoration: 'underline',
						}}>
						<HighlightComponent
							highlightClassName="highlightClass"
							autoEscape={true}
							textToHighlight={value || ''}
						/>
					</div>
				)}
			</>
		),
	},
	{
		title: 'ASN No',
		dataIndex: 'asnNumber',
		sorter: (a, b) => a?.asnNumber - b?.asnNumber,
		key: 'asnNumber',
		width: 100,
		render: (value) => (
			<HighlightComponent highlightClassName="highlightClass" autoEscape={true} textToHighlight={value || ''} />
		),
	},
	{
		title: 'Invoice Date',
		dataIndex: 'invoiceDate',
		sorter: (a, b) => new Date(a.invoiceDate) - new Date(b.invoiceDate),
		key: 'invoiceDate',
		width: 100,
		render: (value) => <span>{moment(value).format(DATE_FORMAT.DD_MM_YYYY)}</span>,
	},
	{
		title: 'Invoice Qty',
		dataIndex: 'invoiceQty',
		align: 'left',
		width: 100,
		sorter: (a, b) => a?.invoiceQty - b?.invoiceQty,
	},
	{
		title: 'Invoice Weight',
		dataIndex: 'invoiceWeight',
		align: 'left',
		width: 100,
		sorter: (a, b) => a?.invoiceWeight - b?.invoiceWeight,
	},
	{
		title: 'Stock Qty',
		dataIndex: 'stockQty',
		align: 'left',
		width: 100,
		sorter: (a, b) => a?.stockQty - b?.stockQty,
	},
	{
		title: 'Status',
		dataIndex: 'status',
		align: 'left',
		width: 100,
		sorter: (a, b) => a?.status?.localeCompare(b?.status),
		render: (value) => <Tag color={STATUS[value]}>{value}</Tag>,
	},
];

export default GRNUpdate;
